import { useInView } from 'react-intersection-observer'
import { useMediaQuery } from 'usehooks-ts'
import { ComplementaryProducts } from '@components/ComplementaryProducts/ComplementaryProducts'
import { SuggestionsDrawer } from '@components/SuggestedProductsDrawer/SuggestedProductsDrawer'
import { useCart } from '@velasca/hooks/use-cart'
import { useSliderProducts } from '@velasca/hooks/use-slider-products'
import { Modal } from '@velasca/ui/modal'
import { transformProductsSliderData } from '@velasca/utils/transform-products-slider-data'
import { Container } from './ShopTheLookModal.styles'
import type { ShopTheLookModalProps } from './ShopTheLookModal.types'

export const ShopTheLookModal = ({
  drawerTitle,
  title,
  subtitle,
  children,
  productIDs,
  isOpen,
  onClose,
  editorialImage = null,
  editorialVideo = null,
}: ShopTheLookModalProps) => {
  const { isDrawerOpen } = useCart()
  const isSmallerThan768px = useMediaQuery('(max-width: 767px)')

  const [ref, isInView] = useInView({
    rootMargin: `100px 0px 100px 0px`,
    triggerOnce: true,
  })

  const { loading, products } = useSliderProducts(productIDs, !isInView)
  const transformedProducts = transformProductsSliderData(products)

  if (!onClose) {
    return children
  }

  return (
    <>
      <Container ref={ref}>{children}</Container>

      {productIDs &&
        isInView &&
        (isSmallerThan768px ? (
          <SuggestionsDrawer
            title={drawerTitle}
            isOpen={isOpen}
            products={transformedProducts}
            loading={loading}
            productIDs={productIDs}
            onClose={() => {
              onClose(false)
            }}
          />
        ) : (
          !isDrawerOpen && (
            <Modal
              open={isOpen}
              className="shop-the-look-modal"
              onOpenChange={(...args) => {
                onClose(...args)
              }}
            >
              <ComplementaryProducts
                products={transformedProducts}
                loading={loading}
                editorialImage={editorialImage}
                editorialVideo={editorialVideo}
                sliderStyles={{ padding: '2.5rem' }}
                loadingSlides={productIDs.length}
                title={title}
                subTitle={subtitle}
                shouldOpenCartDrawerOnAddToCart={false}
              />
            </Modal>
          )
        ))}
    </>
  )
}
